import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class SecureStorageService {

  constructor() { }

  /**
   * Save a key-value pair securely.
   * On iOS/Android, this uses native storage (UserDefaults/SharedPreferences).
   * Note: For critical secrets, consider a dedicated plugin like capacitor-secure-storage-plugin
   * which uses Keychain/Keystore.
   */
  async set(key: string, value: any): Promise<void> {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    await Preferences.set({
      key: key,
      value: stringValue,
    });
  }

  /**
   * Retrieve a value by key.
   */
  async get(key: string): Promise<any> {
    const prefResult = await Preferences.get({ key: key });
    const value = prefResult.value;
    if (!value) {
      return null;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  /**
   * Remove a value by key.
   */
  async remove(key: string): Promise<void> {
    await Preferences.remove({ key: key });
  }

  /**
   * Clear all preferences.
   */
  async clear(): Promise<void> {
    await Preferences.clear();
  }
}
